export default {
    name: "wanadev-loader",
    requires: [],

    load() {
        const WanadevLoaderController = require("./src/wanadev-loader-controller").default;
        this.wanadevLoaderController = new WanadevLoaderController();
        const WanadevLoaderView = require("./src/wanadev-loader-view.vue").default;
        return {
            controller: this.wanadevLoaderController,
            view: WanadevLoaderView,
        };
    },

    unload() {},

    config: {
        // whether or not loader will be directly displayed on load
        showAtStart: false,
    },
};
